import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2, Pencil } from "lucide-react";
import { toast } from "sonner";

const FIELDS = [
  { key: "first_name", label: "Nome" },
  { key: "last_name", label: "Cognome" },
  { key: "phone", label: "Telefono" },
  { key: "email", label: "Email" },
  { key: "company", label: "Azienda" },
  { key: "city", label: "Città" },
  { key: "province", label: "Provincia" },
];

export default function EditLeadModal({ open, onClose, lead, onDone }) {
  const [form, setForm] = useState({});
  const [interests, setInterests] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !lead) return;
    const f = {};
    FIELDS.forEach(({ key }) => { f[key] = lead[key] || ""; });
    setForm(f);
    setInterests((lead.interests || []).join(", "));
  }, [open, lead]);

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...form };
      payload.interests = interests.split(",").map((s) => s.trim()).filter(Boolean);
      await api.put(`/leads/${lead.id}`, payload);
      toast.success("Scheda lead aggiornata");
      onDone && onDone();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore nel salvataggio");
    }
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="edit-lead-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Pencil className="w-5 h-5" /> Modifica scheda lead
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {FIELDS.map(({ key, label }) => (
            <div key={key} className="space-y-1">
              <Label className="text-xs">{label}</Label>
              <Input data-testid={`edit-lead-${key}`} value={form[key] ?? ""}
                onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))} />
            </div>
          ))}
          <div className="space-y-1 sm:col-span-2">
            <Label className="text-xs">Interessi (separati da virgola)</Label>
            <Input data-testid="edit-lead-interests" value={interests}
              onChange={(e) => setInterests(e.target.value)} placeholder="es. Corso A, Corso B" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={saving} data-testid="edit-lead-save">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : null} Salva
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
